import styled from "styled-components"

export const DivContainer = styled.div`
  display: flex;
  flex: 1 auto;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  padding: 10px 0;
`
export const SpanImage = styled.span`
  font-size: 10px;
`

export const BoxImageView = styled.div`
  width: 100px;
  height: auto;
  padding: 0 10px 0 10px;
`
export const Image = styled.img`
  opacity: 1;
  display: block;
  width: 100%;
  height: auto;
  transition: 0.5s ease;
  backface-visibility: hidden;
`
export const InsideBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: inherit;
`

export const GridImage = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  flex-wrap: wrap;
  padding-top: 10px;
  padding-bottom: 10px;
`



// WEBPACK FOOTER //
// ./src/editor/components/image/styled.js